import axios from "./axios";

export default {
    findAllAccountingExpensesEntry(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    findAllAccountingExpensesEntryDCL(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/dcl',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    verifyDuplicatedEntries(value) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/verifyDuplicatedEntries',
            headers: { 'content-type': 'application/json' },
            params: value
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    verifyGenerationCodes(data) {
        const options = {
            method: 'POST',
            url: '/accountingexpensesentry/verifyGenerationCodes',
            headers: { 'content-type': 'application/json' },
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    filteredAccountingExpensesEntry(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filtered',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    filteredAccountingExpensesEntryByDate(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filteredByDate',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Método para filtrar gastos DCL por fecha
    filteredAccountingExpensesEntryByDateDCL(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filteredByDateDCL',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Método para filtrar gastos DCL
    filteredAccountingExpensesEntryDCL(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filteredDCL',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    createAccountingExpensesEntry(data) {
        const options = {
            method: 'POST',
            url: '/accountingexpensesentry',
            headers: { 'content-type': 'multipart/form-data' },
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    ImportAccountingExpenses(data) {
        const options = {
            method: 'POST',
            url: '/accountingexpensesentry/importExpenses',
            headers: { 'content-type': 'multipart/form-data' },
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    ImportAccountingExpensesDCL(data) {
        const options = {
            method: 'POST',
            url: '/accountingexpensesentry/importExpensesDCL',
            headers: { 'content-type': 'multipart/form-data' },
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    // Método para filtrar gastos por fecha y texto de búsqueda
    filteredAccountingExpensesEntryByDateAndSearch(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filteredByDateAndSearch',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Método para filtrar gastos DCL por fecha y texto de búsqueda
    filteredAccountingExpensesEntryByDateAndSearchDCL(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/list/filteredByDateAndSearchDCL',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    deleteAccountingExpenses(id) {
        const options = {
            method: 'DELETE',
            url: '/accountingexpensesentry/deleteExpenses',
            headers: { 'content-type': 'multipart/form-data' },
            params: id,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    
    deleteAccountingExpensesDCL(id) {
        const options = {
            method: 'DELETE',
            url: '/accountingexpensesentry/deleteExpensesDCL',
            headers: { 'content-type': 'multipart/form-data' },
            params: id,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    findAllWithholdingCertificates(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/withholding-certificates',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    filteredWithholdingCertificates(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/withholding-certificates/filtered',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    filteredWithholdingCertificatesByDateAndSearch(params = {}) {
        const options = {
            method: 'GET',
            url: '/accountingexpensesentry/withholding-certificates/filteredByDateAndSearch',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    updateEntryClassification(data) {
        const options = {
            method: 'PATCH',
            url: '/accountingexpensesentry/updateClassification',
            headers: { 'content-type': 'application/json' },
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },

    updateEntryClassificationByDocument(data) {
        const options = {
            method: 'PATCH',
            url: '/accountingexpensesentry/updateClassificationByDocument',
            headers: { 'content-type': 'application/json' },
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },

    deleteWithholdingCertificate(params) {
        const options = {
            method: 'DELETE',
            url: '/accountingexpensesentry/withholding-certificates',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};
